import servicioNotificacion from '@/services/servicio-notificacion';

const notificacion = {
    methods:{
        obtenerNotificaciones(){
            return servicioNotificacion.obtenerNotificacion()
            .then(r=> {
                this.$emit("actualizarNotificaciones",r.data)
                return r;
            })
            .catch(e=> {
                return e;
            })
        }
    }
}

export default notificacion;